import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { HouseOwnerContactsService } from '../../../services/house-owner-contacts.service';
import { RestHouseOwnerContactResponse } from '../../../models/api.models';
import { HouseOwnerContactData } from '../../../services/api.services';

@Component({
  selector: 'app-contact-data',
  templateUrl: './contact-data.component.html',
  styleUrls: ['./contact-data.component.scss'],
})
export class ContactDataComponent implements OnInit {

  houseOwnerContacts: HouseOwnerContactData[] = [];
  count: number = 0;

  @Input() firstName: string;
  @Input() lastName: string;
  @Input() phone: string;
  @Input() email: string;
  @Input() houseId: number;

  constructor(
    private popOverCtrl: PopoverController,
    private houseOwnerContactService: HouseOwnerContactsService,
  ) { }

  ngOnInit() {
    console.log('houseId', this.houseId);
    this.houseOwnerContactService.getHouseOwnerContacts(this.houseId).subscribe((receivedHouseOwnerContacts: RestHouseOwnerContactResponse) => {
      console.log('response', receivedHouseOwnerContacts);
      this.houseOwnerContacts = receivedHouseOwnerContacts.house_owner_contacts;
      this.count = receivedHouseOwnerContacts.count;
    }, error => {
      console.log('error', error);
    });

  }

  salir() {
    this.popOverCtrl.dismiss();
  }

}
